class PaneraMarquee extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.panera-marquee__pause-btn');
    this.track = this.querySelector('.panera-marquee__track');

    if (this.btn && this.track) {
      this.btn.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    const isPaused = this.track.classList.toggle('panera-marquee__track--paused');
    this.btn.setAttribute('aria-pressed', isPaused.toString());
    this.btn.setAttribute('aria-label', isPaused ? 'Play scrolling marquee' : 'Pause scrolling marquee');
    this.btn.classList.toggle('panera-marquee__pause-btn--paused', isPaused);
  }
}

customElements.define('panera-marquee-component', PaneraMarquee);
